$ = require 'jquery'
Alerts = require 'views/lib/alerts'
templates = require 'views/internal/templates'
track = require 'debug/track'

reportedError = false

module.exports = (err, { isUsingSocket, dateLastMessage }) ->
  Alerts.showHtml(templates.fill('sync_error'), 'error', 'modelSync')
  if !reportedError
    reportedError = true

    # We get back an error message that will contain something like
    # "ixSinceUpdate too high: 2 > 1 (...id...)"
    # "ixSinceUpdate too low. 1 < 2 (...id...)"
    parts = /too (low|high)[\.:]\s+(\d+)\s[<>]\s(\d+)/.exec(err.message) || []
    [all, lowOrHigh, value1, value2] = parts

    track('Error', 'Sync Error',
      if isUsingSocket then "Using Socket" else "Using AJAX",
      if parts? then (if lowOrHigh == 'high' then 'Too High' else 'Too Low') else "Unknown",
      # The difference between the two values that came back in the error message,
      # so we have a sense of how far past the queue length we were
      if parts? then Math.abs(parseInt(value1, 10) - parseInt(value2, 10))
    )

    timeSinceGoodConnection = Date.now() - (dateLastMessage || 0)

    $.ajax({
      url: "/test-connection"
      timeout: 3000
    })
    .fail =>
      track('Error', 'Sync Error Connectability', 'Unreachable', undefined, timeSinceGoodConnection)
    .done =>
      track('Error', 'Sync Error Connectability', 'Reachable', undefined, timeSinceGoodConnection)
  return



// WEBPACK FOOTER //
// ./app/scripts/debug/sync-error.coffee